import React from "react";
import Classes from "classnames";

import FormFieldFormElementProto from "../../form-element-proto";
import Textarea from 'core/gd-form/form-element/textarea/textarea';

class StringField extends FormFieldFormElementProto {

    constructor(props) {
        super(props);

        // this._bind('onFocus','onBlur','onChange');
        //
        // this.state = {
        //     isEditing: false,
        //     value: this.props.value
        // }

    }

    onChange(newValue) {

        if (!newValue) newValue = '';

        const { onChange } = this.props;
        this.setState({value: newValue}, ()=>{
            if (onChange) onChange(newValue)
        });
    }

    // onFocus(e) {
    //     this.setState({isEditing: true}, ()=> {
    //         if (this.props.onFocus) this.props.onFocus(e)
    //     });
    // }
    //
    // onBlur(e) {
    //     this.setState({isEditing: false}, ()=>{
    //         if (this.props.onBlur) this.props.onBlur(e);
    //     });
    // }

    render() {

        let classes;

        classes = Classes('gd-form-field-text','form-element',{
        });

        return (

            <div className={classes}>
                <Textarea
                                placeholder=""
                                size="big"
                                // value={this.state.value}
                                // disabled={(this.props.canEdit==false)}

                                // onChange={this.onChange}

                                // onFocus={this.onFocus}
                                // onBlur={this.onBlur}
                                form={this.props.form} name={this.props.name}

                                rows={this.props.field.params.size}
                                cols={60} />
            </div>

        );
    }

}

// StringField.propTypes = props;
// StringField.defaultProps = defaultProps;

export default function renderStringFormFieldFormElement(field, props) {
    return <StringField field={field} {...props} />;
}